import { VERIFICATION_MEDIA_REQUEST, VERIFICATION_MEDIA_SHOW, VERIFICATION_MEDIA_FAIL } from "../store/config";

const mediaInit = {
	isFetching:false,
	list:[],
	error:null
};

const verificationMedia = (state=mediaInit,action) => {
	switch (action.type){
		case VERIFICATION_MEDIA_REQUEST:
			return {
				...state,
				isFetching:action.isFetching,
				timestamp:action.timestamp
			};
		case VERIFICATION_MEDIA_SHOW:
			return {
				...state,
				isFetching:action.isFetching,
				list:action.payload,
				timestamp:action.timestamp
			};
		case VERIFICATION_MEDIA_FAIL:
			return {
				...state,
				isFetching:action.isFetching,
				error:action.error,
				timestamp:action.error
			};
		default:
			return {
				...state
			};
	}
};

export default verificationMedia;


// WEBPACK FOOTER //
// ./src/reducers/verification_media.js